export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_CATEGORY_DATA_LOADING = 'SET_CATEGORY_DATA_LOADING';
export const SET_SEARCH_CATEGORY_BY_ID = 'SET_SEARCH_CATEGORY_BY_ID';
